"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SectionExpandable = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../utils/constants");
var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes"));
var _IconButton = require("../IconButton/IconButton");
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _SectionContent = require("./_SectionContent");
var _SectionTitle = require("./_SectionTitle");
var _Section = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Section.css") : void 0);
const _excluded = ["bodyProps", "buttonClassName", "buttonProps", "className", "collapseLabel", "expandLabel", "headerProps", "headingLevel", "headingProps", "iconName", "iconClassName", "isPanel", "headerClassName", "headingClassName", "titleIsHidden", "title", "onExpand", "expanded", "panelStyle"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const CSS_BLOCK = 'sapcnqr-section';

/**
 * The **SectionExpandable** component is a specialized version of a **Section**
 * that provides a method for showing or hiding the body content.
 *
 * **SectionExpandable** can optionally contain a **SectionExpandable.Content** component.
 */

const SectionExpandable = exports.SectionExpandable = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
      bodyProps,
      buttonClassName,
      buttonProps,
      className,
      collapseLabel = 'Collapse',
      expandLabel = 'Expand',
      headerProps,
      headingLevel = 2,
      headingProps,
      iconName,
      iconClassName,
      isPanel,
      headerClassName,
      headingClassName,
      titleIsHidden,
      title,
      onExpand,
      expanded = true,
      panelStyle
    } = props,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  const expandableId = (0, _useUniqueId.default)();
  const [isExpanded, setExpanded] = (0, _react.useState)(expanded);
  (0, _react.useEffect)(() => {
    setExpanded(expanded);
  }, [expanded]);
  const toggleExpanded = e => {
    setExpanded(!isExpanded);
    if (onExpand) {
      onExpand(!isExpanded, e);
    }
  };
  const classnames = _bind.default.bind(_Section.default);
  const sectionClasses = classnames(className, CSS_BLOCK, `${CSS_BLOCK}--expandable`, {
    [`${CSS_BLOCK}--expanded`]: isExpanded,
    [`${CSS_BLOCK}--panel`]: isPanel,
    [`${CSS_BLOCK}--primary`]: panelStyle === 'primary'
  });
  const headerClasses = classnames(`${CSS_BLOCK}__header`, headerClassName, headerProps?.className);
  return /*#__PURE__*/_react.default.createElement("section", (0, _extends2.default)({}, otherProps, {
    className: sectionClasses,
    ref: ref
  }), /*#__PURE__*/_react.default.createElement("header", (0, _extends2.default)({}, headerProps, {
    className: headerClasses
  }), /*#__PURE__*/_react.default.createElement(_SectionTitle.SectionTitle, (0, _extends2.default)({}, headingProps, {
    iconName: iconName,
    iconClassName: iconClassName,
    headingClassName: headingClassName,
    headingLevel: headingLevel,
    title: title,
    titleIsHidden: titleIsHidden
  })), /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, (0, _extends2.default)({
    ariaLabel: isExpanded ? collapseLabel : expandLabel
  }, buttonProps, {
    "aria-controls": expandableId,
    "aria-expanded": isExpanded,
    "data-test": "btnExpandCollapse",
    className: classnames(`${CSS_BLOCK}__button`, buttonClassName),
    iconName: isExpanded ? 'arrow-2-n' : 'arrow-2-s',
    iconProps: _objectSpread({
      forceSize: 'xs-plus'
    }, buttonProps?.iconProps),
    onClick: toggleExpanded,
    size: isPanel ? 'md' : 'lg'
  }))), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, bodyProps, {
    className: classnames(_constants.CSS_PREFIX, `${CSS_BLOCK}__body`, bodyProps?.className),
    id: expandableId
  }), props.children));
});
SectionExpandable.displayName = 'SectionExpandable';
SectionExpandable.propTypes = {
  /** The “body” of the section; that is, any content that exists outside the `<header>`
   * element but inside the `<section>` element. */
  children: _propTypes.default.node.isRequired,
  /** Content of the section heading. Must not contain only whitespace because concise yet
   * descriptive headings are extremely important to screen readers.
   * If this needs to be visually hidden, set the `titleIsHidden` property to true. */
  title: _propTypes.default.node.isRequired,
  /** Additional props to be spread to the body content `<div>`. */
  bodyProps: _propTypes.default.object,
  /** Custom classes to be added to the expand/collapse `<button>`. */
  buttonClassName: _propTypes.default.string,
  /** Properties to pass through to the button. */
  buttonProps: _propTypes.default.object,
  /** Custom classes to be added to the wrapping `<section>`. */
  className: _propTypes.default.string,
  /** Sets the button’s aria-label attribute when expanded. */
  collapseLabel: _CustomPropTypes.default.localizedString('CoreUIComponents.collapse'),
  /** When false, the children nodes (body content) will be hidden. */
  expanded: _propTypes.default.bool,
  /** Sets the button’s aria-label attribute when collapsed. */
  expandLabel: _CustomPropTypes.default.localizedString('CoreUIComponents.expand'),
  /** DEPRECATED: use `headerProps.className`. Custom classes to be added to the `<header>`. */
  headerClassName: _propTypes.default.string,
  /** Additional props to be spread to the `<header>`. */
  headerProps: _propTypes.default.object,
  /** DEPRECATED: use `headingProps.className`.
   * Custom classes to be added to the `<h#>` tag, where `#` is the `headingLevel`. */
  headingClassName: _propTypes.default.string,
  /** Sets the semantic heading level for the section heading: `<h2>`.
   * Allowable values are 2 through 6. (`<h1>` headings are managed by the framework itself.) */
  headingLevel: _CustomPropTypes.default.range(2, 6),
  /** Additional props to be spread to the **Title** component. */
  headingProps: _propTypes.default.object,
  /** If set, an icon will be displayed to the left of the title text (and will be visible even
   * when `titleIsHidden` is true). A list of available icons and their corresponding names can
   * be found at Available Icons. */
  iconName: _propTypes.default.string,
  /** Custom classes to be added to the title `<Icon />` element. */
  iconClassName: _propTypes.default.string,
  /** @ignore */
  isPanel: _propTypes.default.bool,
  /** @ignore - set by PanelExpandable */
  panelStyle: _propTypes.default.string,
  /** If true, the title text will be hidden from sighted readers but will remain accessible to
   * screen readers. */
  titleIsHidden: _propTypes.default.bool,
  /** Callback function when the section is toggled between expanded and collapsed.
   * @param expanded
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   */
  onExpand: _propTypes.default.func
};
SectionExpandable.Content = _SectionContent.SectionContent;
var _default = exports.default = SectionExpandable;